import commonDataReducer from './redux/reducers/commonDataReducer';
import reportReducer from './redux/reducers/reportReducer';
import emailReducer from './redux/reducers/emailReducers';
import captchaReducer from './redux/reducers/captchaReducer';
import yourAccountReducer from './redux/reducers/yourAccountReducers';
import helpReducer from './redux/reducers/helpReducer';
import paymentReducer from './redux/reducers/paymentReducer';
import viewUserCommonReducer from './redux/reducers/viewUserCommonReducer';
import endorsementsReducers from './redux/reducers/endorsementsReducers'
import * as commonDataServices from './redux/services/commonDataServices';
import * as captchaServices from './redux/services/captchaServices';
import * as emailServices from './redux/services/emailServices';
import * as yourAccountServices from './redux/services/yourAccountServices';
import * as helpServices from './redux/services/helpServices';
import * as paymentServices from './redux/services/paymentConfirmationServices';
import * as typeMsg from './utils/typeNotification';
import * as endorsementsServices from './redux/services/endorsementsServices';
const { warningMsg, errorMsg, infoMsg } = typeMsg

export { default as Load } from './react/components/loading/Load';
export { default as Report } from './react/components/report/Report';
export { default as ReportResults } from './react/components/report/ReportResults';
export { default as EmailData } from './react/components/email/EmailData';
export { default as YourAccount } from './react/components/yourAccount/YourAccount';
export { default as DodAccount } from "./react/components/yourAccount/DodAccount"
export { default as WhatsNew } from './react/components/help/WhatsNew';
export { default as ApplicationGuide } from './react/components/help/ApplicationGuide';
export { default as ContactAFSP } from './react/components/help/ContactAFSP';
export { default as Faqs } from './react/components/help/Faqs';
export { default as Links } from './react/components/help/Links';
export { default as LegalNotice } from './react/components/help/LegalNotice';
export { default as Regulatory } from './react/components/help/Regulatory';
export { default as HelpLayout } from './react/components/help/HelpLayout';
export { default as FaqModal } from './react/components/help/FaqModal';
export { default as EmailView } from './react/components/email/EmailView';
export { default as HomeBadge } from './react/components/help/HomeBadge';
export { default as ErrorModal } from './react/components/errorHandling/ErrorModal';
export { default as ViewUserCommon } from './react/components/viewEditUserCommon/ViewUserCommon';
export { default as UserNotification } from './utils/UserNotification';
export { default as ImageViewer } from './react/components/image-viewer/ImageViewer';
export { default as GenericCaptchaForm } from './react/components/captcha/GenericCaptchaForm';
export { default as PaymentConfirmation } from './react/components/payment/PaymentConfirmation';
export { default as Image } from './react/components/image/Image';
export { default as ExpiredSessionModal } from './react/components/session/ExpiredSessionModal';
export { default as HelpModalContent } from './react/components/help/HelpModalContent';
export { default as EndorseeTableData } from './react/components/endoresments/EndorseeTableData';

export const
commonData = {
    commonDataReducer,
    commonDataServices
},
report = {
    reportReducer
},
email = {
    emailReducer,
    emailServices
},
yourAccount = {
    yourAccountReducer,
    yourAccountServices
},
help = {
    helpReducer,
    helpServices
},
payment = {
    paymentReducer,
    paymentServices
},
viewUserCommon = {
    viewUserCommonReducer
},
ssTypeMsg = {
    warningMsg,
    errorMsg,
    infoMsg
},
captcha = {
    captchaReducer,
    captchaServices
},
endorsements = {
    endorsementsReducers,
    endorsementsServices
};
